import { render } from "./ViewSocietePage.vue?vue&type=template&id=5c96e8f9&ts=true"
import script from "./ViewSocietePage.vue?vue&type=script&lang=ts"
export * from "./ViewSocietePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__